module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "start-xs"
  }, [_c('pl-dialog', {
    attrs: {
      "border-radius": "5px",
      "disableOutsideClick": true,
      "title": (" " + _vm.optionalText + "?"),
      "size": 'lg'
    },
    on: {
      "close": _vm.close
    }
  }, [(_vm.subHeader) ? _c('div', {
    staticClass: "my-3 px-7"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.subHeader) + " ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "remove-teachers flex-grow overflow-y-auto"
  }, [(_vm.teachersToRemove && _vm.teachersToRemove.length > 0) ? _c('div', {
    staticClass: "my-3 px-7"
  }, _vm._l((_vm.teachersToRemove), function(teacher) {
    return _c('div', {
      staticClass: "mt-3"
    }, [_c('span', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v(" " + _vm._s(teacher.name) + " ")]), _vm._v(" "), (teacher.courses && teacher.courses.length > 0) ? _c('div', _vm._l((teacher.courses), function(course) {
      return _c('div', {
        staticClass: "flex w-full m-3"
      }, [_c('div', {
        staticClass: "w-1/3 truncate-text"
      }, [_c('span', [_vm._v(_vm._s(_vm._f("truncate")(course.title, 15)) + "\n                  " + _vm._s(course.sections[0] ? ' - ' + course.sections[0] : '') + "\n                ")])]), _vm._v(" "), _c('div', {
        staticClass: "w-2/3 relative",
        staticStyle: {
          "padding-right": "20px",
          "position": "relative"
        }
      }, [_c('multiselect', {
        attrs: {
          "options": course.teachers,
          "multiple": false,
          "close-on-select": false,
          "clear-on-select": false,
          "preserve-search": true,
          "selected": course.selected_teacher,
          "placeholder": "Stay with teacher",
          "label": "name",
          "track-by": "id",
          "limit": 1,
          "preselect-first": true
        },
        scopedSlots: _vm._u([{
          key: "singleLabel",
          fn: function(ref) {
            var option = ref.option;

            return [_vm._v("\n                    " + _vm._s(option.name) + "\n                  ")]
          }
        }], null, true),
        model: {
          value: (course.selected_teacher),
          callback: function($$v) {
            _vm.$set(course, "selected_teacher", $$v)
          },
          expression: "course.selected_teacher"
        }
      })], 1)])
    }), 0) : _c('div', {
      staticClass: "mt3"
    }, [_c('span', [_vm._v("This teacher doesn't have any course in the school.")])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('pl-input', {
    staticClass: "mt3",
    attrs: {
      "errorMessage": _vm.errorMessage,
      "labelText": _vm.labelText
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitConfirm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.confirm),
      callback: function($$v) {
        _vm.confirm = $$v
      },
      expression: "confirm"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center my-5"
  }, [_c('button', {
    staticClass: "px-7 py-2 mr-2 bg-gray-100 hover:bg-gray-200 rounded cursor-pointer text-gray-400 font-semibold",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        CANCEL\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 bg-pinky hover:bg-pinky-dark rounded cursor-pointer text-white font-semibold",
    on: {
      "click": _vm.submitConfirm
    }
  }, [_vm._v("\n        DELETE\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-820ec6c2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/dialogDeleteTeachersConfirm.vue
// module id = 2056
// module chunks = 61